import { Brand } from '../../types';

export const calculateTotalBudget = (brand: Brand, budget: number) => {
  if (brand?.allowSetupPayment) {
    return budget / (1 - brand?.budgetPercentageFee / 100);
  }

  return budget / ((brand?.budgetOffset || 100) / 100);
};
